import { useState } from 'react';
import { useRouter } from 'next/router';
import Scrollbar from '@/components/ui/scrollbar';
import { useDrawer } from '@/components/drawer-views/context';
import { CloseIcon } from '@/components/icons/close-icon';
import { useTranslation } from 'next-i18next';
import ProductFilterAccordions from './product-filter-accordions';
import { Button, Radio, RadioGroup, cn } from '@nextui-org/react';
import { sortables } from '@/lib/constants';

export default function ProductSortingDrawerView() {
  const { closeDrawer } = useDrawer();
  const { t } = useTranslation('common');
  const router = useRouter();
  function handleChange(value: any) {
    // const { orderBy, sortedBy } = values;
    router.push(
      {
        pathname: router.pathname,
        query: {
          ...router.query,
          orderBy: value,
        },
      },
      undefined,
      { scroll: false }
    );
  }
  return (
    <div className="flex h-full flex-col">
      <div className="flex h-[70px] items-center justify-between py-2 px-5 sm:px-7">
        <h2 className="text-sm font-medium capitalize text-dark dark:text-light">
          Sorting
        </h2>
        <div className="ml-3 flex h-7 items-center">
          <button
            type="button"
            className="-m-2 p-2 text-dark-800 outline-none transition-all hover:text-dark hover:dark:text-light-200"
            onClick={closeDrawer}
          >
            <span className="sr-only">{t('text-close-panel')}</span>
            <CloseIcon className="h-4 w-4" />
          </button>
        </div>
      </div>
      {/* <Scrollbar className="w-full flex-1 py-6 px-5 sm:px-7"> */}
        <RadioGroup
          size="lg"
          className='p-5 text-lg'
          value={
            sortables.find(
              (sortable) => sortable.value === router.query.orderBy
            )?.value ?? sortables[0].value
          }
          onChange={(e) => handleChange(e.target.value)}
        >
          {sortables.map((sortable) => (
            <Radio size='lg' className='text-lg' classNames={{
              label: 'text-lg'
            }} key={sortable.value} value={sortable.value}>
              {sortable.label}
            </Radio>
          ))}
        </RadioGroup>
      {/* </Scrollbar> */}
      <div className="mt-auto flex justify-center border-t border-light-300 px-5 py-6 align-middle dark:border-dark-500 sm:px-7 sm:pb-8 sm:pt-7">
        <Button
          onClick={closeDrawer}
          disableRipple
          size="lg"
          radius="full"
          className="bg-brand text-white"
        >
          View results
        </Button>
      </div>
    </div>
  );
}
